module.exports = __webpack_public_path__ + "static/media/Kjole.d07bfb43.mp3";